

const options= {
    Commercial:{
        PropertyType:{ 
            'All Commercial':'All Commercial',
            'Business':'Business',
            'Multi Family':'Multi Family',
            'Retail':'Retail',
            'Industrial':'Industrial',
            'Office':'Office',
            'Vacant Land':'Vacant Land',
            'Agriculture':'Agriculture',
            'Hospitality':'Hospitality',
            'Institutional':'Institutional'
        },
        TransactionType:{
            'For sale':'For sale',
            'For lease':'For lease'
        },
        PriceMin:{
            '0':'0',
            '25000':'25,000',
            '50000':'50,000',
            '75000':'75,000',
            '100000':'100,000',
            '125000':'125,000',
            '150000':'150,000',
            '175000':'175,000',
            '200000':'200,000',
            '225000':'225,000',
            '250000':'250,000',
            '275000':'275,000',
            '300000':'300,000',
            '325000':'325,000',
            '350000':'350,000',
            '375000':'375,000',
            '400000':'400,000',
            '425000':'425,000',
            '450000':'450,000',
            '475000':'475,000',
            '500000':'500,000',
            '550000':'550,000',
            '600000':'600,000',
            '650000':'650,000',
            '700000':'700,000',
            '750000':'750,000',
            '800000':'800,000',
            '850000':'850,000',
            '900000':'900,000',
            '950000':'950,000',
            '1000000':'1,000,000',
            '1100000':'1,100,000',
            '1200000':'1,200,000',
            '1300000':'1,300,000',
            '1400000':'1,400,000',
            '1500000':'1,500,000',
            '1600000':'1,600,000',
            '1700000':'1,700,000',
            '1800000':'1,800,000',
            '1900000':'1,900,000',
            '2000000':'2,000,000',
            '2500000':'2,500,000',
            '3000000':'3,000,000',
            '3500000':'3,500,000',
            '4000000':'4,000,000',
            '4500000':'4,500,000',
            '5000000':'5,000,000',
            '5500000':'5,500,000',
            '6000000':'6,000,000',
            '6500000':'6,500,000',
            '7000000':'7,000,000',
            '7500000':'7,500,000',
            '10000000':'10,000,000',
            '15000000':'15,000,000',
            '20000000':'20,000,000'
        },
        PriceMax:{
            '0':'Unlimited',
            '25000':'25,000',
            '50000':'50,000',
            '75000':'75,000',
            '100000':'100,000',
            '125000':'125,000',
            '150000':'150,000',
            '175000':'175,000',
            '200000':'200,000',
            '225000':'225,000',
            '250000':'250,000',
            '275000':'275,000',
            '300000':'300,000',
            '325000':'325,000',
            '350000':'350,000',
            '375000':'375,000',
            '400000':'400,000',
            '425000':'425,000',
            '450000':'450,000',
            '475000':'475,000',
            '500000':'500,000',
            '550000':'550,000',
            '600000':'600,000',
            '650000':'650,000',
            '700000':'700,000',
            '750000':'750,000',
            '800000':'800,000',
            '850000':'850,000',
            '900000':'900,000',
            '950000':'950,000',
            '1000000':'1,000,000',
            '1100000':'1,100,000',
            '1200000':'1,200,000',
            '1300000':'1,300,000',
            '1400000':'1,400,000',
            '1500000':'1,500,000',
            '1600000':'1,600,000',
            '1700000':'1,700,000',
            '1800000':'1,800,000',
            '1900000':'1,900,000',
            '2000000':'2,000,000',
            '2500000':'2,500,000',
            '3000000':'3,000,000',
            '3500000':'3,500,000',
            '4000000':'4,000,000',
            '4500000':'4,500,000',
            '5000000':'5,000,000',
            '5500000':'5,500,000',
            '6000000':'6,000,000',
            '6500000':'6,500,000',
            '7000000':'7,000,000',
            '7500000':'7,500,000',
            '10000000':'10,000,000',
            '15000000':'15,000,000',
            '20000000':'20,000,000'
        },
        
        parkingType:{
            '35':'Boat House',
            '36':'Concrete',
            '37':'Heated Garage',
            '1':'Attached garage',
            '2':'Integrated garage',
            '3':'Detached garage',
            '4':'Garage',
            '5':'Carport',
            '6':'Underground',
            '7':'Indoor',
            '8':'Open',
            '9':'Covered',
            '10':'Parking pad',
            '11':'Paved Yard'
        },
        hospitalityBuildingType:{
            ' ':'Any',
            '1':'House',
            '16':'Row / Townhouse',
            '17':'Apartment',
            '2':'Duplex',
            '3':'Triplex',
            '19':'Fourplex',
            '20':'Garden Home',
            '6':'Mobile Home',
            '27':'Manufactured Home/Mobile',
            '12':'Special Purpose',
            '5':'Residential Commercial Mix',
            '29':'Manufactured Home',
            '28':'Commercial Apartment',
            '25':'Two Apartment House',
            '30':'Park Model Mobile Home'
        },
        institutionalBuildingType:{
            ' ':'Any',
            '12':'Special Purpose',
            '7':'Offices',
            '5':'Residential Commercial Mix',
            '4':'Multi-Family',
            '8':'Retail',
            '9':'Warehouse',
            '14':'Other'
        },
        industrialBuildingType:{
            ' ':'Any',
            '12':'Special Purpose',
            '7':'Offices',
            '5':'Residential Commercial Mix',
            '4':'Multi-Family',
            '8':'Retail',
            '9':'Warehouse',
            '14':'Other'
        },
        retailBuildingType:{
            ' ':'Any',
            '8':'Retail',
            '21':'Flex Facility',
            '5':'Residential Commercial Mix',
            '23':'Multi-Tenant Industrial',
            '24':'Commercial Mix',
            '7':'Offices',
            '9':'Warehouse',
            '19':'Fourplex',
            '4':'Multi-Family',
            '12':'Special Purpose',
            '14':'Other'
        },
        zoningType:{
            '4':'Commercial Retail',
            '3':'Commercial Office',
            '2':'Commercial Mixed',
            '5':'Industrial',
            '7':'Industrial-Light',
            '8':'Industrial-Medium',
            '6':'Industrial-Heavy',
            '13':'Residential-Low Density',
            '14':'Residential - Medium Density',
            '12':'Residential-High Density',
            '9':'Institutional',
            '1':'Agricultural',
            '11':'Recreational',
            '10':'Other'
        }

    },
    Residential:{
        PropertyType:{
            '0':'No Preference',
            '1':'Residential',
            '2':'Recreational',
            '3':'Condo/Strata',
            '8':'Multi Family',
            '4':'Agriculture',
            '5':'Parking',
            '6':'Vacant Land'
        },
        TransactionType:{
            'For sale':'For sale',
            'For rent':'For rent'
        },
        PriceMin:{
            '0':'0',
            '100':'100',
            '200':'200',
            '300':'300',
            '400':'400',
            '500':'500',
            '600':'600',
            '700':'700',
            '800':'800',
            '900':'900',
            '1000':'1,000',
            '1200':'1,200',
            '1400':'1,400',
            '1600':'1,600',
            '1800':'1,800',
            '2000':'2,000',
            '2500':'2,500',
            '3000':'3,000',
            '3500':'3,500',
            '4000':'4,000',
            '4500':'4,500',
            '5000':'5,000',
            '6000':'6,000',
            '7000':'7,000',
            '8000':'8,000',
            '9000':'9,000',
            '10000':'10,000'
        },
        PriceMax:{
            '0':'Unlimited',
            '100':'100',
            '200':'200',
            '300':'300',
            '400':'400',
            '500':'500',
            '600':'600',
            '700':'700',
            '800':'800',
            '900':'900',
            '1000':'1,000',
            '1200':'1,200',
            '1400':'1,400',
            '1600':'1,600',
            '1800':'1,800',
            '2000':'2,000',
            '2500':'2,500',
            '3000':'3,000',
            '3500':'3,500',
            '4000':'4,000',
            '4500':'4,500',
            '5000':'5,000',
            '6000':'6,000',
            '7000':'7,000',
            '8000':'8,000',
            '9000':'9,000',
            '10000':'10,000'
        },
        farmType:{
            '1':'Animal',
            '3':'Cash Crop',
            '7':'Hobby Farm',
            '6':'Market Gardening',
            '5':'Nursery',
            '10':'Greenhouse',
            '9':'Orchard',
            '8':'Vineyard',
            '4':'Feed Lot',
            '2':'Boarding',
            '12':'Mixed'
        },
      
       
        'buildingAttachmentStyle':{
            '116':'Attached',
            '31':'Detached',
            '32':'Detached',
            '33':'Detached',
            '316':'Detached',
            '51':'Semi-detached',
            '52':'Semi-detached',
            '53':'Semi-detached',
            '516':'Semi-detached',
            '11':'Attached',
            '12':'Attached',
            '13':'Attached',
            '72':'Stacked',
            '716':'Stacked',
            '91':'Link'
        }
      
    },

    'Common':{
        SizeInterior:{
            '':'Any',
            '0-5000':'0-5,000 sqft',
            '5001-10000':'5,001 - 10,000 sqft',
            '10001-15000':'10,001 - 15,000 sqft',
            '15001-20000':'15,001 - 20,000 sqft',
            '20001-25000':'20,001 - 25,000 sqft',
            '25001-30000':'25,001 - 30,000 sqft',
            '30001-35000':'30,001 - 35,000 sqft',
            '35001-40000':'35,001 - 40,000 sqft',
            '40001-45000':'40,001 - 45,000 sqft',
            '45001-50000':'45,001 - 50,000 sqft',
            '50001-75000':'50,001 - 75,000 sqft',
            '75001-100000':'75,001 - 100,000 sqft',
            '100001-150000':'100,001 - 150,000 sqft',
            '150001-200000':'150,001 - 200,000 sqft',
            '200001-250000':'200,001 - 250,000 sqft',
            '250001-0':'Over 250,000 sqft'
        },
        BedroomsTotal:{
            '0-0':'Any',
            '1-1':'1',
            '1-0':'1+',
            '2-2':'2',
            '2-0':'2+',
            '3-3':'3',
            '3-0':'3+',
            '4-4':'4',
            '4-0':'4+',
            '5-5':'5',
            '5-0':'5+'
        },
        BathroomTotal:{
            '0-0':'Any',
            '1-1':'1',
            '1-0':'1+',
            '2-2':'2',
            '2-0':'2+',
            '3-3':'3',
            '3-0':'3+',
            '4-4':'4',
            '4-0':'4+',
            '5-5':'5',
            '5-0':'5+'
        },
        SizeTotal:{
            '0':'Any',
            '1':'1+ acres',
            '2':'2+ acres',
            '5':'5+ acres',
            '10':'10+ acres',
            '50':'50+ acres',
            '100':'100+ acres',
            '200':'200+ acres',
            '300':'300+ acres',
            '400':'400+ acres',
            '500':'500+ acres',
            '1000':'1000+ acres'
        },
        Type:{
            ' ':'Any',
            '1':'House',
            '16':'Row / Townhouse',
            '17':'Apartment',
            '2':'Duplex',
            '3':'Triplex',
            '19':'Fourplex',
            '20':'Garden Home',
            '6':'Mobile Home',
            '27':'Manufactured Home/Mobile',
            '12':'Special Purpose',
            '5':'Residential Commercial Mix',
            '29':'Manufactured Home',
            '28':'Commercial Apartment',
            '25':'Two Apartment House',
            '30':'Park Model Mobile Home'
        },
        numberOfUnits:{
            '0-0':'Any',
            '1-1':'One',
            '1-0':'One or more',
            '2-2':'Two',
            '2-0':'Two or more',
            '3-3':'Three',
            '3-0':'Three or more',
            '4-4':'Four',
            '4-0':'Four or more',
            '1-4':'Less than five',
            '5-5':'Five',
            '5-0':'Five or more',
            '6-6':'Six',
            '6-0':'Six or more',
            '7-7':'Seven',
            '7-0':'Seven or more',
            '8-8':'Eight',
            '8-0':'Eight or more',
            '9-9':'Nine',
            '9-0':'Nine or more'
        },
        'keywords':{
            'Hot tub':'Hot tub',
            'Jacuzzi':'Jacuzzi',
            'Whirlpool':'Whirlpool',
            'Sauna':'Sauna',
            'Eco-friendly':'Eco-friendly',
            'High efficiency':'High efficiency',
            'Air conditioning':'Air conditioning',
            'Workshop':'Workshop',
            'BBQ':'BBQ',
            'Open concept':'Open concept',
            'Renovated':'Renovated',
            'Walkout basement':'Walkout basement',
            'Nanny suite':'Nanny suite',
            'Granny suite':'Granny suite',
            'Income suite':'Income suite',
            'Rental suite':'Rental suite',
            'Pet friendly':'Pet friendly',
            'Pets allowed':'Pets allowed',
            'Wood fireplace':'Wood fireplace',
            'Gas fireplace':'Gas fireplace',
            'Fenced yard':'Fenced yard',
            'Ensuite bathroom':'Ensuite bathroom',
            'Stainless steel appliances':'Stainless steel appliances',
            'Finished basement':'Finished basement',
            'Bungalow':'Bungalow',
            'Victorian':'Victorian',
            'Contemporary':'Contemporary',
            'Solar panels':'Solar panels',
            'Insuite laundry':'Insuite laundry',
            'Hardwood floors':'Hardwood floors',
            'Inlaw suite':'Inlaw suite',
            'High efficiency furnace':'High efficiency furnace',
            'Salt water':'Salt water',
            'Custom woodwork':'Custom woodwork',
            'Granite':'Granite',
            'High-end appliances':'High-end appliances',
            'Modern':'Modern',
            'Crown mouldings':'Crown mouldings',
            'wood burning':'wood burning',
            'Smart Buildings':'Smart Buildings',
            'Smart Centers':'Smart Centers',
            'solar water heater':'solar water heater',
            'Co-op housing':'Co-op housing',
            'co-operative':'co-operative',
            'Wifi':'Wifi',
            'design':'design',
            'desirable':'desirable',
            'Urban':'Urban',
            'Loft':'Loft',
            'Adult lifestyle':'Adult lifestyle',
            'investment':'investment',
            'ramp':'ramp',
            'Accessible':'Accessible',
            'Gate':'Gate',
            'Zone':'Zone',
            'Garage':'Garage',
            'Landmarks':'Landmarks',
            'sq ft':'sq ft',
            'Gated Community':'Gated Community',
            'Fireplace':'Fireplace',
            'pet allowed':'pet allowed',
            'rental income':'rental income',
            'barn':'barn',
            'basement apartment':'basement apartment',
            'income apartment':'income apartment',
            'basement suite':'basement suite',
            'River Front':'River Front'
        }
    }
    
};


export default (key,parent='Common')=>{
    const values=options[parent][key];

    
    return Object.keys(values).map((value)=>{
        return {label:values[value],value};
    });
};

